import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { Provider } from 'react-redux';
import { persistor, store } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from '@sentry/react';
import { AuthProvider } from './context/AuthProvider';
import AppErrorBoundary from './components/ErrorBoundary';

if (
  import.meta.env.VITE_APP_ENV === 'production' &&
  import.meta.env.VITE_PUBLIC_SENTRY_DSN
) {
  Sentry.init({
    dsn: import.meta.env.VITE_PUBLIC_SENTRY_DSN,
    environment: import.meta.env.VITE_APP_ENV,
    release: import.meta.env.VITE_APP_VERSION || '1.0.0',
    dist:
      import.meta.env.VITE_APP_ENV === 'production' ? 'production' : 'sandbox',
  });
}
const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <AppErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </PersistGate>
      </Provider>
    </AppErrorBoundary>,
  );
}
